function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.75 8C0.75 3.99621 3.99621 0.75 8 0.75C12.0038 0.75 15.25 3.99621 15.25 8C15.25 12.0038 12.0038 15.25 8 15.25C3.99621 15.25 0.75 12.0038 0.75 8Z",
  stroke: "#4B5563",
  strokeWidth: 1.5
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9 4.43333C9 4.3 9 4.16667 8.93333 4.1C8.86667 3.96667 8.8 3.9 8.73333 3.83333C8.66667 3.76667 8.53333 3.7 8.4 3.63333C8.26667 3.56667 8.13333 3.5 8 3.5C7.73333 3.5 7.53333 3.56667 7.33333 3.76667C7.13333 3.96667 7 4.16667 7 4.43333V8.56667C7 8.83333 7.13333 9.03333 7.33333 9.23333C7.53333 9.43333 7.73333 9.5 8 9.5C8.26667 9.5 8.46667 9.43333 8.66667 9.23333C8.86667 9.03333 9 8.83333 9 8.56667V4.43333ZM8 10.4333C7.73333 10.4333 7.46667 10.5 7.33333 10.7C7.2 10.9 7.06667 11.1 7.06667 11.3667C7.06667 11.6333 7.13333 11.9 7.33333 12.0333C7.53333 12.2333 7.73333 12.3 8 12.3C8.26667 12.3 8.53333 12.2333 8.66667 12.0333C8.86667 11.8333 8.93333 11.6333 8.93333 11.3667C8.93333 11.1 8.86667 10.8333 8.66667 10.7C8.53333 10.5 8.26667 10.4333 8 10.4333Z",
  fill: "#4B5563"
});
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.102171b97d22da9b1363c6b5889dd327.svg";
export { ForwardRef as ReactComponent };